import { render, staticRenderFns } from "./AllPermission.vue?vue&type=template&id=14807136&scoped=true"
import script from "./AllPermission.vue?vue&type=script&lang=js"
export * from "./AllPermission.vue?vue&type=script&lang=js"
import style0 from "./AllPermission.vue?vue&type=style&index=0&id=14807136&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14807136",
  null
  
)

export default component.exports